import { useUserStore } from '@/store/modules/user/store.js';
import { get } from 'lodash-es';
import { useAccountStore } from '@/store/modules/account/store.js';
import router from '@/router/index.ts';
import { isLeadGuest } from '@/utils/leadGuest.js';
import i18n from '../plugins/vue-i18n.js';

import { useContextStore } from './modules/context/store.ts';

export default {
    groupDisplay() {
        return (
            !empty(useContextStore().group.id) ||
            get(useAccountStore().contextAccount, 'account_manager', false)
        );
    },

    sources() {
        const sources = [
            {
                id: null,
                name: i18n.t('general.none'),
            },
        ];

        const accountSources = useAccountStore().contextAccount?.sources || [];

        if (empty(accountSources)) {
            return sources;
        }

        for (const source of accountSources) {
            source.name = source.name.trim();
            sources.push(source);
        }

        if (!empty(sources)) {
            // Sort
            sources.sort((a, b) => a.name.localeCompare(b.name));
        }

        return sources;
    },

    sourcesWithProvider() {
        const sources = [
            {
                id: null,
                name: i18n.t('general.none'),
            },
        ];

        const accountSourcesWithProvider =
            useAccountStore().contextAccount?.sourcesWithProvider || [];

        if (empty(accountSourcesWithProvider)) {
            return sources;
        }

        for (const source of accountSourcesWithProvider) {
            source.name = source.name.trim();
            sources.push(source);
        }

        if (!empty(sources)) {
            // Sort
            sources.sort((a, b) => a.name.localeCompare(b.name));
        }

        return sources;
    },

    guest() {
        const user = useUserStore().authUser;
        const lead = useContextStore().lead;

        if (router.currentRoute.value?.name !== 'leads.update') {
            return false;
        }

        return isLeadGuest(user, lead, useAccountStore().contextAccount);
    },
};
